import { createProvider } from '@nvision/services/data-provider';
import { queryOptions } from '@tanstack/react-query';

import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import { CACHE_KEYS } from '../../types';
import { logger } from '../../utils/logger';
import * as api from './api';
import { normalizeContract } from './normalize';

export const fetchContract = createProvider(api.fetchContract)
  .andThen(normalizeContract)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      logger.warn('Fetch contract is aborted');
    } else {
      showNotification({ message: 'Fetch contract was failed', type: NOTIFICATION_TYPES.ERROR });
      logger.error(`Fetch contract was failed: ${error}`);
    }
    throw error;
  });

export const contractQueryOptions = (contractKey?: string) =>
  queryOptions({
    enabled: Boolean(contractKey),
    queryFn: ({ signal }) => fetchContract(contractKey ?? '', { signal }),
    queryKey: CACHE_KEYS.contract(contractKey),
    // biome-ignore lint/style/noMagicNumbers: 1 hour
    staleTime: 1000 * 60 * 60,
  });
